import React from "react";
import IconPreview from "../BuilderComponents/Preview/IconPreview";
import { parseCustomCss } from "../../Pages/FlexibleLayout/utils";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const DropdownPreview = ({ config, classes }) => {
  const customStyles = config?.custom_css ? parseCustomCss(config.custom_css) : {};
  return (
    <button className={`z-dropdown-btn ${classes}`} style={{ ...customStyles }}>
      {config.icon && <IconPreview icon={config.icon || ""} />}
      <span>{config.name}</span>
      <MaterialIcon name="keyboard_arrow_down" />
    </button>
  );
};

export default DropdownPreview;
